module.exports = __webpack_public_path__ + "static/img/business11.f79089c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business11.jpg
// module id = vwE7
// module chunks = 9